// Package Imports
// import { TagOutlined } from '@ant-design/icons';
import ModuleIdentifierConst from 'core/common/moduleIdentifier';

// Project Imports
import resourceName from 'core/common/resourceName';
import ResourceItem from 'interfaces/resource';

const attributeIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="currentColor"
    className="size-6"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M9.568 3H5.25A2.25 2.25 0 0 0 3 5.25v4.318c0 .597.237 1.17.659 1.591l9.581 9.581c.699.699 1.78.872 2.607.33a18.095 18.095 0 0 0 5.223-5.223c.542-.827.369-1.908-.33-2.607L11.16 3.66A2.25 2.25 0 0 0 9.568 3Z"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M6 6h.008v.008H6V6Z"
    />
  </svg>
);

const AttributeResource: ResourceItem = {
  name: resourceName.attribute,
  identifier: ModuleIdentifierConst.ATTRIBUTE,
  list: `${resourceName.attribute}`,
  show: `${resourceName.attribute}/show/:id`,
  create: `${resourceName.attribute}/create`,
  edit: `${resourceName.attribute}/edit/:id`,
  options: {
    label: 'Attribute',
    icon: attributeIcon,
  },
};

export default AttributeResource;
